// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".skillOrChance_skill__YBcR1 {\n  white-space: pre-wrap;\n  margin-top: 25px;\n  font-weight: normal;\n  line-height: 120%;\n}\n.skillOrChance_skill__YBcR1 h3 {\n  margin-bottom: 15px;\n}\n.skillOrChance_skill__YBcR1 .skillOrChance_quote__WAzDK {\n  color: var(--text-yellow);\n  font-style: italic;\n}", ""]);
// Exports
exports.locals = {
	"skill": "skillOrChance_skill__YBcR1",
	"quote": "skillOrChance_quote__WAzDK"
};
module.exports = exports;
